export var ACTION;
(function (ACTION) {
    ACTION["CLOSE_PARENT_MODAL"] = "CLOSE_PARENT_MODAL";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["VALIDATE_BANK"] = "VALIDATE_BANK";
    ACTION["NAVIGATE_IFSC"] = "NAVIGATE_IFSC";
    ACTION["VALIDATE_PAN"] = "VALIDATE_PAN";
    ACTION["VALIDATE_GST"] = "VALIDATE_GST";
    ACTION["VALIDATE_IFSC"] = "VALIDATE_IFSC";
    ACTION["VALIDATE_IRN"] = "VALIDATE_IRN";
    ACTION["SEARCH_IFSC_ACTION"] = "SEARCH_IFSC_ACTION";
})(ACTION || (ACTION = {}));
